import * as z from "zod";

export const configurationSchema = z
  .object({
    execute_actions_on_alert_to_ok: z.boolean().default(true),
  })
  .default({ execute_actions_on_alert_to_ok: true });

export const timeRestrictionSchema = z
  .object({
    start: z.string().default("00:00"),
    end: z.string().default("23:59"),
  })
  .nullable()
  .default(null);

export type TimeRestrictionSchema = z.infer<typeof timeRestrictionSchema>;
